import { createFileRoute, useSearch, Link } from '@tanstack/react-router'
import { useEffect } from 'react'
import { CheckCircle2, AlertCircle } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { getOAuthErrorMessage } from '@/lib/google-calendar-oauth'

export const Route = createFileRoute('/google-calendar-callback')({
  validateSearch: (search: Record<string, unknown>) => ({
    status: (search.status as string) || '',
    email: (search.email as string) || '',
    connection_id: (search.connection_id as string) || '',
    reason: (search.reason as string) || '',
  }),
  component: GoogleCalendarCallback,
})

function GoogleCalendarCallback() {
  const { status, email, connection_id, reason } = useSearch({ from: '/google-calendar-callback' })
  useEffect(() => {
    if (window.opener) {
      window.opener.postMessage({ status, email, connection_id, reason }, window.location.origin)
      window.close()
    }
  }, [status, email, connection_id, reason])

  const isSuccess = status === 'connected'

  // Fallback UI if popup couldn't close (or user navigated directly)
  return (
    <div className="flex items-center justify-center min-h-dvh">
      <div className="text-center space-y-4 max-w-md mx-auto p-6">
        {isSuccess ? (
          <>
            <CheckCircle2 className="h-12 w-12 text-green-600 mx-auto" />
            <h1 className="text-xl font-semibold">Verbindung erfolgreich</h1>
            <p className="text-muted-foreground">
              Ihr Google-Konto{email ? ` (${email})` : ''} wurde erfolgreich verbunden.
            </p>
          </>
        ) : (
          <>
            <AlertCircle className="h-12 w-12 text-red-600 mx-auto" />
            <h1 className="text-xl font-semibold">Verbindung fehlgeschlagen</h1>
            <p className="text-muted-foreground">
              {getOAuthErrorMessage(reason ?? '')}
            </p>
          </>
        )}
        <Button asChild>
          <Link to="/integrations">Zurück zu Integrationen</Link>
        </Button>
      </div>
    </div>
  )
}
